<template>
  <div>
    <!-- <b-breadcrumb style="background-color:#f8f9fa" :items="itemsBreadcrumb"></b-breadcrumb> -->
    <b-row>
      <b-col cols="12">
        <b-overlay :show="isLoading" rounded="sm">
          <b-card class="shadow-sm pt-0 pl-0 pr-0 m-4 mb-0">
            <b-navbar toggleable="lg">
              <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
              <b-navbar-brand href="#">
                <strong style="color:#3b3e66">Governance</strong>
              </b-navbar-brand>

              <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav class="ml-auto">
                  <b-nav-form>
                    <b-button
                      variant="outline-info"
                      size="sm"
                      class="mr-2"
                      @click="setGovernanceTableData"
                    >
                      <font-awesome-icon icon="sync" />
                    </b-button>
                    <b-form-group>
                      <b-input-group size="sm">
                        <b-form-input
                          v-model="filter"
                          type="search"
                          id="filterInput"
                          placeholder="Type to Search"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-nav-form>
                </b-navbar-nav>
              </b-collapse>
            </b-navbar>

            <b-table
              striped
              sticky-header="calc(100vh - 295px)"
              ref="table"
              id="users-data-table"
              :busy.sync="isLoading"
              :fields="staticFields"
              :items="governanceTableItems"
              :filter="filter"
              hover
              :per-page="perPage"
              :current-page="currentPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
            >
              <template v-slot:thead-top>
                <b-tr>
                  <b-th colspan="1">
                    <span class="sr-only">Name</span>
                  </b-th>
                  <b-th colspan="4" variant="secondary">Policy Attestations</b-th>
                  <b-th colspan="2" variant="primary">Training</b-th>
                </b-tr>
              </template>
              <template v-slot:table-colgroup="scope">
                <col
                  v-for="field in scope.fields"
                  :key="field.key"
                  :style="field.width ? 'width:'+field.width : ''"
                />
              </template>
              <template
                v-slot:cell(employee_name)="data"
              >{{data.item.first_name + ' ' + data.item.last_name}}</template>
              <template v-slot:cell()="data">
                <div v-if="setTasksColumns.length > 0">
                  <div
                    v-for="(tasksColumns,tasksColumnsIndex) in setTasksColumns"
                    :key="tasksColumnsIndex"
                  >
                    <div v-for="(tasks,tasksIndex) in data.item.tasks" :key="tasksIndex">
                      <div v-if="setTasksKeyConditon(data,tasks,tasksColumns)">
                        <b-badge v-if="tasks.task_status == '0'" variant="info">Pending</b-badge>
                        <b-badge v-if="tasks.task_status == '1'" variant="warning">In Progress</b-badge>
                        <b-badge v-if="tasks.task_status == '2'" variant="danger">On hold</b-badge>
                        <b-badge v-if="tasks.task_status == '3'" variant="dark">Review</b-badge>
                        <div v-if="tasks.task_status == '4'">
                          <b-badge variant="success">Complete</b-badge>
                          <div class="text-left">
                            <span>Last completed:</span>
                            <span class="text-muted">{{createdAtDate(tasks.updated_at)}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-slot:cell(actions)="data">
                <b-button size="sm" variant="outline-info" @click="data.toggleDetails">
                  <font-awesome-icon
                    :icon="data.detailsShowing ? 'minus' : 'plus'"
                    title="View Tasks"
                  />
                </b-button>
              </template>
              <template v-slot:row-details="row">
                <b-card style="height: 22rem;">
                  <b-table
                    fixed
                    :fields="taskTableFields"
                    :items="row.item.tasks"
                    small
                    head-variant="dark"
                  >
                    <template v-slot:cell(created_at)="data">
                      <p>{{ createdAtDate(data.item.created_at) }}</p>
                    </template>
                    <template v-slot:cell(task_title)="data">
                      <p class="link-text" @click="setUserTaskUrl(data)">{{data.item.task_title}}</p>
                    </template>
                    <template v-slot:cell(task_status)="data">
                      <b-badge v-if="data.item.task_status == '0'" variant="info">Pending</b-badge>
                      <b-badge v-if="data.item.task_status == '1'" variant="warning">In Progress</b-badge>
                      <b-badge v-if="data.item.task_status == '2'" variant="danger">On hold</b-badge>
                      <b-badge v-if="data.item.task_status == '3'" variant="dark">Review</b-badge>
                      <b-badge v-if="data.item.task_status == '4'" variant="success">Completed</b-badge>
                    </template>
                  </b-table>

                  <b-button size="sm" @click="row.toggleDetails">Hide Details</b-button>
                </b-card>
              </template>
            </b-table>
            <template v-slot:footer>
              <b-row>
                <b-col cols="2">
                  <b-form-select
                    v-model="perPage"
                    id="perPageSelect"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select>
                </b-col>
                <b-col cols="6">
                  <p class="text-center">
                    Displaying Result From
                    <b>{{fromRows}}</b> to
                    <b>{{toRows}}</b>
                  </p>
                </b-col>
                <b-col cols="4">
                  <b-pagination
                    class="float-right"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last"
                    aria-controls="my-table"
                  ></b-pagination>
                </b-col>
              </b-row>
            </template>
          </b-card>
        </b-overlay>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { HTTP } from "../../../utils/HTTP";
import moment from "moment";
import "moment/locale/es";
export default {
  name: "OptionTwo",
  data() {
    return {
      itemsBreadcrumb: [
        {
          text: "Dashboard",
          href: "dashboard",
        },
        {
          text: "Onboarding",
          href: "#",
          active: true,
        },
      ],
      isLoading: false,
      totalRows: 0,
      fromRows: 0,
      toRows: 0,
      filter: null,
      perPage: 10,
      currentPage: 1,
      sortBy: "id",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 75, 100],
      governanceTableItems: [],
      setTasksColumns: [],
      staticFields: [
        {
          key: "actions",
          label: "",
          sortable: false,
        },
        {
          key: "employee_name",
          label: "Employee",
          sortable: true,
        },
      ],
      taskTableFields: [
        {
          key: "created_at",
          label: "Age",
          sortable: true,
        },

        {
          key: "task_title",
          label: "Task Title",
          sortable: true,
        },
        {
          key: "task_status",
          label: "Status",
          sortable: true,
        },
      ],
      onboardingId: null,
    };
  },
  computed: {
    rows() {
      return this.totalRows;
    },
  },
  mounted() {
    this.setGovernanceTableData();
  },
  methods: {
    createdAtDate(value) {
      moment.locale("en");
      return moment(value).format("DD/MM/YYYY");
    },
    setUserTaskUrl(data) {
      if (
        data.item.form_type == 1 ||
        data.item.form_type == 8 ||
        data.item.form_type == 10
      ) {
        localStorage.removeItem("taskId");
        localStorage.removeItem("activeFormSchema");
        localStorage.removeItem("taskFormData");
        localStorage.removeItem("activeTaskStatus");

        localStorage.setItem("taskId", data.item.id);
        this.$router.push("/emplyee-user-form/" + data.item.id + "/2");
      } else if (data.item.form_type == 3) {
        localStorage.removeItem("taskId");
        localStorage.removeItem("activeFormSchema");
        localStorage.removeItem("taskFormData");
        localStorage.removeItem("activeTaskStatus");

        localStorage.setItem("taskId", data.item.id);
        this.$router.push("/emplyee-training/" + data.item.id + "/2");
      } else if (data.item.form_type == 6) {
        localStorage.removeItem("taskId");
        localStorage.removeItem("activeFormSchema");
        localStorage.removeItem("taskFormData");
        localStorage.removeItem("activeTaskStatus");

        localStorage.setItem("taskId", data.item.id);
        this.$router.push("/employee-pdf-training/" + data.item.id + "/2");
      } else if (data.item.form_type == 4) {
        localStorage.setItem("taskId", data.item.id);
        this.getTaskForm(data.item.id);
      }
    },

    async getTaskForm(taskId) {
      this.formButtom = true;
      let token = "Bearer " + localStorage.getItem("accessToken");
      let result = await HTTP(
        "post",
        "api/v1/onboarding/employee/task/detail",
        {
          task_id: taskId,
          formType: 4,
        },
        {
          Authorization: token,
        },
        null,
        true
      );
      if (result.data.task) {
        let form = result.data.task.schema;
        let form_data = JSON.parse(result.data.task.form_data);
        this.$store.state.userFormSubmitArray = form_data;
        localStorage.setItem("activeFormSchema", form);
        localStorage.setItem("activeTaskStatus", result.data.task.task_status);
        localStorage.setItem(
          "examAttemptsToDate",
          result.data.task.exam_attempts_count
        );

        this.$router.push("/emplyee-user-exam/" + taskId + "/2");
      }
    },
    setTasksKeyConditon(data, tasks, tasksColumns) {
      let tasksKey = tasks.task_title.toLowerCase().replace(/\s/g, "_");
      if (data.field.key == tasksKey) {
        if (tasksKey == tasksColumns.key) {
          if (data.field.key == tasksColumns.key) {
            return true;
          }
        }
      } else {
        return false;
      }
    },
    async setGovernanceTableData() {
      this.governanceTableItems = [];
      this.staticFields = [];
      this.setTasksColumns = [];
      let formData = {
        filter: this.filter,
        sort: this.sortBy + "|" + (this.sortDesc == true ? "desc" : "asc"),
        per_page: this.perPage,
        page: this.currentPage,
      };
      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem("accessToken");
      try {
        const response = await HTTP(
          "post",
          "api/v1/governance/training/data",
          formData,
          {
            Authorization: token,
          }
        );
        this.staticFields = [
          {
            key: "actions",
            label: "",
            sortable: false,
          },
          {
            key: "employee_name",
            label: "Employee",
            sortable: true,
          },
        ];
        this.setTasksHeadings(response);
      } catch (err) {
        this.isLoading = false;
        return [err];
      }
    },
    setTasksHeadings(response) {
      response.data.data.map((tableData, index) => {
        tableData.tasks.map((tasksItems) => {
          let fieldKey = tasksItems.task_title
            .toLowerCase()
            .replace(/\s/g, "_");
          if (index == 0) {
            this.staticFields.push({
              key: fieldKey,
              label: tasksItems.task_title,
              sortable: false,
            });
            this.setTasksColumns.push({
              key: fieldKey,
              text: tasksItems.task_title,
              form_type: tasksItems.form_type,
            });
          }
        });
      });
      this.fromRows = response.data.from;
      this.toRows = response.data.to;
      this.totalRows = response.data.total;
      this.governanceTableItems = response.data.data;
      this.isLoading = false;
    },
  },
};
</script>

<style scoped>
@import "../../../assets/styles/theme1/tabs.css";
@import "../../../assets/styles/theme1/timeline.css";

.link-text {
  color: rgb(0 123 255);
  text-decoration: none;
  background-color: rgb(0 0 0 / 0%);
  cursor: pointer;
}
.link-text:hover {
  color: rgb(0 86 179);
  text-decoration: underline;
}

.card-body {
  padding: 0px;
}

.fixed-bottom {
  right: auto !important;
  left: auto !important;
  width: 100%;
}
</style>

<style>
body {
  font-family: Heebo, sans-serif;
  font-size: 0.95rem;
  font-weight: 400;
  line-height: 1.5;
  color: #3b3e66;
}

.card-header {
  /* #background-color:#dcdef1; */
  /* padding: 0.4rem 0.4rem; */

  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #fff;
  border-bottom: 0 solid rgba(122, 123, 151, 0.3);
}

/* .table .thead-light th {
    color: #3b3e66;
    background-color: rgba(239,239,247,.7);
    border-color: #dcdef1;
} */
.table {
  font-size: 0.83125rem;
  color: #3b3e66;
}

.table.b-table > thead > tr .table-b-table-default {
  background-color: rgba(239, 239, 247, 0.7);
  color: #3b3e66;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: #f9fafe;
  color: #3b3e66;
}

.table thead th {
  text-transform: uppercase;
  font-size: 0.83125rem;
  border-color: #dcdef1;
  vertical-align: bottom;
  border-bottom: 2px solid #dcdef1;
}

.form-group {
  margin-bottom: 0rem;
}

.group-prepend > .btn,
.input-group-sm > .input-group-append > .btn {
  font-size: 0.75rem;
}

.progress {
  height: 0.5rem;
}

.btn-sm {
  font-size: 0.75rem;
}
</style>
